import { ClickAwayListener, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";

import FormTextFieldDark from "@/components/UI/FormTextFieldDark/FormTextFieldDark";
import { ELEMENT_FORM_STATE, ELEMENT_METHOD } from "@/constants";
import { ArrowDownIcon } from "@/icons";
import { getMediaLink } from "@/utils/mediaLink";

import AudioPreview from "../AudioPreview/AudioPreview";

const useStyles = makeStyles({
  container: {
    position: "relative",
  },
  list: {
    padding: "16px",
    border: "1px solid #323232",
    background: "#000",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.25), 0px 1px 2px 1px rgba(0, 0, 0, 0.25)",
    margin: "0 auto",
    width: "calc(100% - 32px)",
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    position: "absolute",
    top: "56px",
    left: "16px",
    zIndex: "999",
    maxHeight: "216px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#161616",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "4px 16px",
    gap: "8px",
    borderRadius: "8px",
    cursor: "pointer",
    "&:hover": {
      background: "#300013",
    },
  },
});

export default function AssetsAutocomplete(props) {
  const {
    mediaItems,
    formValues,
    control,
    setValue,
    elementFormState,
    setElementFormState,
    previewUrl,
    setPreviewUrl,
    element,
  } = props;
  const classes = useStyles();
  const { fileName } = formValues;

  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!fileName || fileName.length < 2) {
      setOptions(mediaItems);
    } else {
      setOptions(mediaItems.filter((item) => item.name.toLowerCase().indexOf(formValues.fileName.toLowerCase()) > -1));
    }
  }, [mediaItems.length, formValues.fileName]);

  return (
    <>
      {formValues.memoMethod === ELEMENT_METHOD.FROM_LIBRARY && (
        <AudioPreview
          elementFormState={elementFormState}
          previewUrl={previewUrl}
          replace={() => {
            setValue("fileName", "", { shouldDirty: true });
            setValue("url", "", { shouldDirty: true });
            setValue("linkedId", "", { shouldDirty: true });
            setPreviewUrl("");
            setElementFormState(ELEMENT_FORM_STATE.REPLACE);
          }}
          type={element.type}
        />
      )}
      <div className={classes.container} data-testid="assets-autocomplete-field-container">
        <FormTextFieldDark
          name="fileName"
          control={control}
          label="Select voice memo from assets"
          variant="standard"
          fullWidth
          autoComplete="off"
          onFocus={() => {
            setIsOpen(true);
          }}
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => setIsOpen(true)}>
                <ArrowDownIcon htmlColor="#757575" />
              </IconButton>
            ),
          }}
        />
        {isOpen && !!options.length && (
          <ClickAwayListener
            onClickAway={(e) => {
              if (e.target.name !== "fileName") {
                setIsOpen(false);
              }
            }}
          >
            <div className={classes.list}>
              {options.map((option) => (
                <div
                  className={classes.listItem}
                  key={`list-item-${option.id}`}
                  onClick={() => {
                    setValue("fileName", option.name, { shouldDirty: true });
                    setValue("url", option.link, { shouldDirty: true });
                    setValue("linkedId", option.id, { shouldDirty: true });
                    setPreviewUrl(getMediaLink({ link: option.link }));
                    setElementFormState(ELEMENT_FORM_STATE.PREVIEW);
                    setIsOpen(false);
                  }}
                >
                  {option.name}
                </div>
              ))}
            </div>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
}
